import { read } from "../lib/read";

// A hint stream has no JSON read registration or retained-detail invalidation edges.
export const NOTIFICATION_EVENTS_URI = "/v1/notifications";

export const notifications = {
  page: read({
    at: "/v1/notifications/page",
    refusal: "surface",
    staleAfter: [
      "POST /v1/learning/sessions/{session_id}/cancellation",
      "POST /v1/notifications/acknowledgements",
      "POST /v1/notifications/acknowledgement-batches",
      "POST /v1/notifications/archive-batches",
    ],
  }),
};
